<nav>
  @for (link of navLinks; track link) {
    <app-nav-elem [link]="link"></app-nav-elem>
  }
</nav>
